import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { BackIcon } from './icons';
import { useDispatch } from 'react-redux';
import { setSkipClicked } from '../store/signup';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 0px 24px;
  position: relative;
  width: 100%;
  margin: 0 auto;
  &::after {
    content: '';
    display: block;
    width: 100%;
    max-width: 343px;
    height: 1px;
    background: #d9ebf1;
    position: absolute;
    bottom: 0px;
    margin-bottom: 16px;
  }
  img {
    width: 19px;
    height: 24px;
  }
  ${({ $withSkip }) =>
    $withSkip &&
    css`
      max-width: 343px;
      @media screen and (max-width: 450px) {
        max-width: 100%;
      }
    `}
  ${({ $customStyles }) =>
    $customStyles &&
    css`
      ${$customStyles};

      @media screen and (max-width: 450px) {
        max-width: ${({ $customStyles }) => ($customStyles ? '343px' : '100%')};
      }
    `}

  @media screen and (max-width: 450px) {
    &::after {
      width: 100vw;
      max-width: none;
    }
  }
  ${({ $withBottomLine }) =>
    !$withBottomLine &&
    css`
      margin-bottom: 0px;
      padding-bottom: 0px;
      &::after {
        display: none;
      }
    `}
  ${({ $isOptions }) =>
    $isOptions &&
    css`
      position: absolute;
      top: 0;
    `}
`;

const GzText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #23cca8;
`;

const SkipBtn = styled.div`
  position: absolute;
  right: 0;
  top: 14px;
  font-size: 14px;
  text-transform: uppercase;
  color: #90959a;
  transition: all 0.3s;
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  @media screen and (max-width: 450px) {
    right: 6px;
  }
`;

const BackBtn = styled.div`
  position: absolute;
  left: 0;
  top: 12px;
  width: 20px;
  height: 20px;
  svg {
    min-width: 20px;
    min-height: 20px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

const AppHeaderLogo = ({
  withBottomLine = true,
  isOptions,
  withSkip = false,
  withBackBtn = false,
  customStyles = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };
  const handleSkipClick = () => {
    dispatch(setSkipClicked(true));
    navigate('/signup');
  };
  return (
    <LogoWrapper
      $withBottomLine={withBottomLine}
      $isOptions={isOptions}
      $withSkip={withSkip}
      $withBackBtn={withBackBtn}
      $customStyles={customStyles}
    >
      {withBackBtn && (
        <BackBtn onClick={handleBackClick}>
          <BackIcon />
        </BackBtn>
      )}
      <img src="../assets/welcome/small-logo.png" alt="header logo" />
      <GzText>Geozilla</GzText>
      {withSkip && <SkipBtn onClick={handleSkipClick}>skip</SkipBtn>}
    </LogoWrapper>
  );
};

export default AppHeaderLogo;
